import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

import { Trans, useLingui } from '@lingui/react/macro';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { createQueryHasEverPairedDevice } from 'src/api/queries';
import { AppPage } from 'src/components/AppPage';
import { PillNav, PillTab } from 'src/components/PillNav';
import { createPageMetaTitle } from 'src/utils/createPageMetaTitle';

const searchSchema = z.object({ showOtp: z.boolean().optional().catch(false) });

export const Route = createFileRoute('/_auth/_layout/device')({
  staticData: { title: createPageMetaTitle('Devices and apps') },
  component: () => <DeviceApp />,
  validateSearch: searchSchema,
  async loader({ context }) {
    return context.queryClient.ensureQueryData(
      createQueryHasEverPairedDevice()
    );
  },
});

export const DeviceApp = () => {
  const { t } = useLingui();
  return (
    <AppPage.Container>
      <AppPage.Header
        className="max-w-l2xl"
        title={t`Devices and apps`}
        subtitle={t`Pair a new device, manage our apps, or get Read on reMarkable for
        Microsoft Office and Google Chrome.`}
      />

      <AppPage.Content className="max-w-l2xl gap-24">
        <PillNav>
          <PillTab
            data-cy="device-link-Tablet"
            to="/device/remarkable"
            componentLocation={ComponentLocations.DEVICE.APPS}
          >
            <Trans>Tablet</Trans>
          </PillTab>
          <PillTab
            data-cy="device-link-apps"
            to="/device/apps"
            match="prefix"
            componentLocation={ComponentLocations.DEVICE.APPS}
          >
            <Trans>Apps</Trans>
          </PillTab>
          <PillTab
            data-cy="device-link-ReadOnReMarkable"
            to="/device/browser"
            componentLocation={ComponentLocations.DEVICE.APPS}
          >
            <Trans>Read on reMarkable</Trans>
          </PillTab>
        </PillNav>

        <Outlet />
      </AppPage.Content>
    </AppPage.Container>
  );
};
